module.exports = __webpack_public_path__ + "img/dashboardTwo4.c8a7ae65.png";